import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService, categoriesService } from "../services/api";
import OrgCategoryMultiSelect from "../components/OrgCategoryMultiSelect";

const empty = {
  title: "",
  slug: "",
  excerpt: "",
  body_html: "<p></p>",
  meta_title: "",
  meta_description: "",
  status: "draft",
  published_at: "",
  is_active: true,
  tag_names: "",
};

const BlogRanduPostEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = id === "new";
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(!isNew);
  const [saving, setSaving] = useState(false);
  const [file, setFile] = useState(null);

  const [orgCatOptions, setOrgCatOptions] = useState([]);
  const [organization_category_ids, setOrganizationCategoryIds] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await categoriesService.getAllFlat();
      if (res.success && Array.isArray(res.data)) setOrgCatOptions(res.data);
    })();
  }, []);

  useEffect(() => {
    if (isNew) return;
    (async () => {
      try {
        const res = await randuBlogService.getPost(id);
        if (!res.success) return;
        const p = res.post;
        const tags = (res.tags || []).map((t) => t.name).join(", ");
        const orgIds = (res.organization_categories || []).map((c) => c.id);
        setOrganizationCategoryIds(orgIds.length ? orgIds : p.organization_category_id ? [p.organization_category_id] : []);
        setForm({
          title: p.title || "",
          slug: p.slug || "",
          excerpt: p.excerpt || "",
          body_html: p.body_html || "",
          meta_title: p.meta_title || "",
          meta_description: p.meta_description || "",
          status: p.status || "draft",
          published_at: p.published_at ? p.published_at.slice(0, 16) : "",
          is_active: p.is_active !== 0,
          tag_names: tags,
        });
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [id, isNew]);

  const onSave = async () => {
    setSaving(true);
    try {
      const tag_names = form.tag_names
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const payload = {
        title: form.title,
        slug: form.slug || undefined,
        excerpt: form.excerpt,
        body_html: form.body_html,
        meta_title: form.meta_title,
        meta_description: form.meta_description,
        status: form.status,
        published_at: form.published_at || null,
        is_active: form.is_active,
        organization_category_ids,
        tag_names,
      };
      let res;
      let postId = isNew ? null : parseInt(id, 10);
      if (isNaN(postId)) postId = null;
      if (isNew) {
        res = await randuBlogService.createPost(payload);
        if (res.success && res.id) postId = res.id;
      } else {
        res = await randuBlogService.updatePost(id, payload);
      }
      if (res.success && file && postId) {
        await randuBlogService.uploadCover(postId, file);
      }
      if (res.success) {
        if (isNew && postId) navigate(`/blog-randu/posts/${postId}`);
        else alert("Kaydedildi");
      } else alert(res.message || "Hata");
    } catch (e) {
      alert(e.message || "Hata");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <MasterLayout>
        <Breadcrumb title="Blog yazısı" />
        <p>Yükleniyor…</p>
      </MasterLayout>
    );
  }

  return (
    <MasterLayout>
      <Breadcrumb title={isNew ? "Yeni blog yazısı" : `Blog #${id}`} />
      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-8">
              <label className="form-label">Başlık</label>
              <input
                className="form-control"
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Slug</label>
              <input
                className="form-control"
                value={form.slug}
                onChange={(e) => setForm({ ...form, slug: e.target.value })}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Özet</label>
              <textarea
                className="form-control"
                rows={2}
                value={form.excerpt}
                onChange={(e) => setForm({ ...form, excerpt: e.target.value })}
              />
            </div>
            <div className="col-12">
              <label className="form-label">HTML içerik</label>
              <textarea
                className="form-control font-monospace"
                rows={14}
                value={form.body_html}
                onChange={(e) => setForm({ ...form, body_html: e.target.value })}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Meta başlık</label>
              <input
                className="form-control"
                value={form.meta_title}
                onChange={(e) => setForm({ ...form, meta_title: e.target.value })}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Meta açıklama</label>
              <input
                className="form-control"
                value={form.meta_description}
                onChange={(e) => setForm({ ...form, meta_description: e.target.value })}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Durum</label>
              <select
                className="form-select"
                value={form.status}
                onChange={(e) => setForm({ ...form, status: e.target.value })}
              >
                <option value="draft">Taslak</option>
                <option value="published">Yayında</option>
                <option value="scheduled">Zamanlanmış</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Yayın tarihi</label>
              <input
                type="datetime-local"
                className="form-control"
                value={form.published_at}
                onChange={(e) => setForm({ ...form, published_at: e.target.value })}
              />
            </div>
            <OrgCategoryMultiSelect
              label="İşletme kategorileri (randu.app vitrin / filtre)"
              options={orgCatOptions}
              value={organization_category_ids}
              onChange={setOrganizationCategoryIds}
              disabled={saving}
            />
            <div className="col-12">
              <label className="form-label">Etiketler (virgülle)</label>
              <input
                className="form-control"
                value={form.tag_names}
                onChange={(e) => setForm({ ...form, tag_names: e.target.value })}
              />
            </div>
            <div className="col-12 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="active"
                checked={form.is_active}
                onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
              />
              <label className="form-check-label" htmlFor="active">
                Aktif (sitede listelensin)
              </label>
            </div>
            <div className="col-12">
              <label className="form-label">Kapak görseli yükle</label>
              <input type="file" accept="image/*" className="form-control" onChange={(e) => setFile(e.target.files?.[0] || null)} />
              {isNew && (
                <p className="form-text small text-muted mb-0">
                  Yeni yazıda önce Kaydet; ardından aynı oturumda seçtiğiniz dosya otomatik yüklenir.
                </p>
              )}
            </div>
          </div>
          <div className="mt-4 d-flex gap-2">
            <button type="button" className="btn btn-primary" disabled={saving} onClick={onSave}>
              {saving ? "Kaydediliyor…" : "Kaydet"}
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={() => navigate("/blog-randu/posts")}>
              Listeye dön
            </button>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduPostEditPage;
